import { useEffect } from 'react';
import WebPhone from '../components/WebPhone'
import { useLocation, useNavigate } from 'react-router-dom';
import { useToast } from '../context/ToastContext';

const CallPage = () => {
  const { addToast } = useToast();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const isSuccess = params.get('payment') === 'success';

    if (isSuccess) {
      addToast('success', 'Credits added successfully!');

      // Remove the query param from URL after showing toast
      const newParams = new URLSearchParams(location.search);
      newParams.delete('payment');
      navigate({ search: newParams.toString() }, { replace: true });
    }
  }, [location.search, addToast, navigate]);

  return (
    <WebPhone />
  );
};
  
  export default CallPage;
  